import { atom } from "jotai";

// In flight while GET /promotions/home is outstanding. Like every other
// isFetching… flag it is not cleared on sign-out (see sessionAtoms): it
// settles in the read's own `finally`.
export const isFetchingHomePromotionsAtom = atom<boolean>(false);
